<template>
    <div class="main-content">
        <the-header :title="t('Applications')" :buttons="headerButtons"/>
        <grid v-on:changePage="$router.push({name: $route.name, params: {page: $event}})"
              :page="parseInt($route.params.page)"
        />
    </div>
</template>

<script>
    import TheHeader from '../../../admin/Layout/TheHeader'
    import Grid from './grid'

    export default {
        components: {
            TheHeader,
            Grid
        },
        methods: {

        },
        data() {
            return {
                headerButtons: [
                    {
                        type: 'link',
                        to: {name: 'selectApplicationUser',params: {patientId: 0}},
                        key: 'create',
                        name: this.t('Create'),
                        icon: 'plus',
                        styleClass: 'btn-success',
                        visible: () => {
                            return this.hasPermission('ApplicationsTitan', 'C');
                        }
                    }
                ],
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/applications/list.vue